import { datadogRum } from '@datadog/browser-rum';
import serverVars from 'server-vars';
import { initDatadogRum, setDatadogRumUserId } from 'dibs-checkout/exports/datadog';
import { PdpType } from './pdpTypes';

const DD_RUM = serverVars.get('DD_RUM');
const locale = serverVars.get('locale');
type DeviceType = 'resp' | 'mobile';

export const initPdpDatadogRum = ({
    device,
    pdpType,
}: {
    device: DeviceType;
    pdpType: PdpType;
}): void => {
    if (!DD_RUM) {
        return;
    }

    const sampleRate = DD_RUM.pdpSampleRate / 100;
    if (Math.random() >= sampleRate) {
        return;
    }

    initDatadogRum();
    setDatadogRumUserId();
    datadogRum.startView({
        name: 'pdp',
        service: DD_RUM.service,
        version: DD_RUM.version,
    });
    datadogRum.setGlobalContextProperty('dibsDevice', device);
    datadogRum.setGlobalContextProperty('dibsPdpType', pdpType);
    datadogRum.setGlobalContextProperty('dibsLocale', locale);
};
